export default {
  SELECT: 'select',
  WITH_INPUT: 'with_input',
  SEARCH_SELECT: 'search_select'
};
